import {
  LARGE_BREAKPOINT,
  MEDIUM_BREAKPOINT,
  SMALL_BREAKPOINT,
} from './../../components/modular-grid/constants';
import { GameTableType } from './../../types/gameTypes';

export const PORTAL_VERTICAL_GAME_TYPES: { [key: string]: GameTableType } = {
  Baccarat: 'Baccarat',
  Blackjack: 'Blackjack',
  DragonTiger: 'DragonTiger',
  ScalableBlackjack: 'ScalableBlackjack',
  Roulette: 'Roulette',
  Poker: 'Poker',
  MoneyWheel: 'MoneyWheel',
  TopCard: 'TopCard',
  Trivia: 'Trivia',
  Monopoly: 'Monopoly',
  SicBo: 'SicBo',
  DealNoDeal: 'DealNoDeal',
  SidebetCity: 'SidebetCity',
  LightningDice: 'LightningDice',
};

export const BAD_GAME = ['game-invalid', 'launch-urk-invalid'];

export const IMAGE_SIZES = {
  small: [
    {
      max: 500,
      size: 90,
    },
    {
      max: SMALL_BREAKPOINT.max,
      size: 160,
    },
    {
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 110,
    },
    {
      min: LARGE_BREAKPOINT.min,
      size: 160,
    },
  ],
  large: [
    {
      max: 500,
      size: 140,
    },
    {
      max: SMALL_BREAKPOINT.max,
      size: 270,
    },
    {
      min: MEDIUM_BREAKPOINT.min,
      max: MEDIUM_BREAKPOINT.max,
      size: 280,
    },
    {
      min: LARGE_BREAKPOINT.min,
      size: 330,
    },
  ],
};

export const GAME_LAUNCH_PLACEMENT = 'search';

export const CONTEXT_ATTRIBUTES = ['game_launch_placement', 'locale'];

export const WEB_ATTRIBUTES = ['game_launch_placement', 'segments'];

export const DYNAMIC_PATH_REGEX = /\/:id$/gm;
